<div class="relative flex flex-row h-full w-full" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div
        class="absolute inset-0 z-10 overflow-hidden bg-zinc-200/40 dark:bg-zinc-900/60 backdrop-blur-md flex items-center justify-center">

        <button type="button" (click)="closeCreatorProfile()"
            class="absolute top-2 left-2 z-20 rounded-full bg-zinc-200 dark:bg-zinc-600 p-1.5 sm:p-2 text-primary shadow-sm hover:bg-zinc-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-5 sm:size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>

        </button>

        <div class="relative w-[90%] h-[90%] primary-card-container flex flex-col overflow-hidden gap-y-2">
            <div aria-hidden="true" class="absolute inset-x-0 transform-gpu overflow-hidden blur-3xl sm:-top-80">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]">
                </div>
            </div>

            <div class="shrink-0 z-10 w-full h-full grid grid-cols-3 overflow-hidden">
                <article class="col-span-1 h-full flex flex-col overflow-hidden">
                    <!-- Sidebar Main -->
                    <div class="flex-1 w-full overflow-hidden p-4">
                        <div class="h-full w-full overflow-y-auto flex flex-col gap-y-6 scrollbar-transparent">
                            <!-- Creator Header -->
                            <div class="flex items-center gap-4">
                                <div class="size-20 shrink-0 overflow-hidden rounded-full ring-4 ring-card lg:size-24">
                                    <atom-ldg-img class="size-full" inputClass="size-full object-cover" w="full"
                                        h="full" radius="full"
                                        [src]="imageService.getImageSource(creator.photoURL, 'gallery')"></atom-ldg-img>
                                </div>
                                <div class="min-w-0">
                                    <div class="flex items-center gap-1.5">
                                        <h2 id="creator-profile-name"
                                            class="m-0 truncate text-3xl font-bold text-primary">
                                            {{ displayName() }}
                                        </h2>
                                        @if (creator.isVerified) {
                                        <img class="size-5" src="assets/social-icon/verified_badge.svg"
                                            alt="Verified" />
                                        }
                                    </div>
                                    <p class="m-0 mt-1 text-sm text-secondary">
                                        {{ formatService.getFlag(creator) }}
                                        {{ creator.homeTownName ? creator.homeTownName : 'Unset' }}
                                        @if (creator.dateOfBirth) {
                                        <span aria-hidden="true"> · </span>
                                        {{ formatService.calculateAge(creator.dateOfBirth) }} yrs
                                        }
                                    </p>
                                    @if (creator.interests.length) {
                                    <div class="mt-2 flex flex-wrap gap-1.5 lg:hidden">
                                        @for (interest of creator.interests; track interest) {
                                        <p
                                            class="m-0 rounded-full bg-brand-purple/10 px-2 py-1 text-xs font-semibold text-brand-agency-dark dark:bg-brand-purple/25 dark:text-primary">
                                            {{ formatService.getInterestText(interest) }}
                                        </p>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>
                            <!-- Creator Header - END-->

                            <div class="flex flex-col gap-y-4">
                                <!-- Creator Stats -->
                                <div
                                    class="grid shrink-0 grid-cols-3 overflow-hidden rounded-lg border border-border bg-card">
                                    <div class="border-r border-border px-3 py-3">
                                        <p class="m-0 text-xl font-extrabold text-primary">{{ reachLabel() }}</p>
                                        <p
                                            class="m-0 mt-1 text-xs font-semibold uppercase tracking-widest text-secondary">
                                            Total reach</p>
                                    </div>
                                    <div class="border-r border-border px-3 py-3">
                                        <p class="m-0 text-xl font-extrabold text-primary">{{ engagementLabel() }}</p>
                                        <p
                                            class="m-0 mt-1 text-xs font-semibold uppercase tracking-widest text-secondary">
                                            Avg. eng.</p>
                                    </div>
                                    <button type="button"
                                        class="px-3 py-3 text-left hover:bg-muted focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-primary"
                                        (click)="setSelectedTab('reviews')" aria-label="Open reviews tab">
                                        <p class="m-0 text-xl font-extrabold text-primary">{{ ratingLabel() }}</p>
                                        <p
                                            class="m-0 mt-1 text-xs font-semibold uppercase tracking-widest text-secondary">
                                            @if (ratingSummary().count === 1) {
                                            1 review
                                            } @else if (ratingSummary().count != null) {
                                            {{ ratingSummary().count }} reviews
                                            } @else {
                                            Reviews
                                            }
                                        </p>
                                    </button>
                                </div>
                                <!-- Creator Stats - END -->

                                <!-- Connected Accounts -->
                                <section class="flex flex-col gap-1" aria-label="Connected accounts">
                                    <div class="overflow-hidden rounded-lg border border-border bg-card">
                                        @if (connectedAccountRows().length === 0) {
                                        <p class="m-0 px-3 py-2.5 text-sm text-secondary">No social accounts connected
                                        </p>
                                        } @else {
                                        @for (account of connectedAccountRows(); track account.platform) {
                                        <div
                                            class="flex items-center gap-2 border-t border-border first:border-t-0 hover:bg-muted">
                                            <button type="button"
                                                class="flex min-w-0 flex-1 items-center gap-2 px-3 py-2.5 text-left focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                                                (click)="openAccountTab(account.platform)">
                                                <img [src]="account.iconSrc" alt=""
                                                    class="size-6 shrink-0 rounded-sm object-contain" />
                                                <div class="min-w-0 flex-1">
                                                    <p class="m-0 truncate text-sm font-regular text-primary">
                                                        {{ account.handle ? '@' + account.handle : account.label }}
                                                    </p>
                                                </div>
                                                <div class="flex shrink-0 items-baseline gap-2">
                                                    @if (account.engagementLabel) {
                                                    <p
                                                        class="m-0 text-sm font-regular uppercase tracking-widest text-secondary">
                                                        {{ account.engagementLabel }}
                                                    </p>
                                                    }
                                                    <p class="m-0 text-md font-extrabold text-primary">{{
                                                        account.followersLabel }}</p>
                                                </div>
                                            </button>
                                            @if (account.profileUrl) {
                                            <a *appHasRole="[2,4,6,77]" [href]="account.profileUrl" target="_blank"
                                                rel="noopener noreferrer"
                                                class="inline-flex size-8 shrink-0 items-center justify-center rounded-lg text-secondary hover:bg-muted hover:text-primary"
                                                [attr.aria-label]="'Open ' + account.label + ' profile'">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                                    stroke="currentColor" stroke-width="2" class="size-4"
                                                    aria-hidden="true">
                                                    <path d="M15 3h6v6" />
                                                    <path d="M10 14 21 3" />
                                                    <path
                                                        d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                                </svg>
                                            </a>
                                            }
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                fill="currentColor"
                                                class="mr-3 size-6 shrink-0 text-green-500 dark:text-green-400"
                                                aria-hidden="true">
                                                <path fill-rule="evenodd"
                                                    d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                        </div>
                                        }
                                        }
                                    </div>
                                </section>
                                <!-- Connected Accounts - END -->
                            </div>

                            <!-- Recent Brands -->
                            <section class="flex flex-col gap-1">
                                <p class="m-0 text-sm font-semibold uppercase tracking-widest text-secondary">Recent
                                    brands</p>
                                @if (recentBrands() && recentBrands()!.total > 0) {
                                <div #recentBrandsRow [class]="recentBrandsExpanded()
                                      ? 'flex w-full flex-wrap items-center gap-1.5'
                                      : 'flex w-full flex-nowrap items-center gap-1.5 overflow-hidden'">
                                    @for (logo of visibleRecentBrandLogos(); track $index) {
                                    <img [src]="imageService.getImageSource(logo, 'gallery')" alt=""
                                        class="size-8 shrink-0 rounded-full border border-border bg-card object-cover" />
                                    }
                                    @if (hiddenRecentBrandCount() > 0) {
                                    <button type="button"
                                        class="shrink-0 rounded-full bg-brand-purple/10 px-2.5 py-1 text-xs font-semibold text-brand-agency-dark hover:bg-brand-purple/20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-brand-purple/25 dark:text-primary dark:hover:bg-brand-purple/40"
                                        (click)="toggleRecentBrands()">
                                        + {{ hiddenRecentBrandCount() }} more
                                    </button>
                                    } @else if (canCollapseRecentBrands()) {
                                    <button type="button"
                                        class="shrink-0 rounded-full bg-brand-purple/10 px-2.5 py-1 text-xs font-semibold text-brand-agency-dark hover:bg-brand-purple/20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-brand-purple/25 dark:text-primary dark:hover:bg-brand-purple/40"
                                        (click)="toggleRecentBrands()">
                                        Show less
                                    </button>
                                    }
                                </div>
                                } @else if (recentBrands() && recentBrands()?.total == 0) {
                                <p class="m-0 text-sm text-secondary italic">New to SHOUT. No collabs yet.</p>
                                } @else {
                                <p class="m-0 text-sm text-secondary italic">Loading brands...</p>
                                }
                            </section>
                            <!-- Recent Brands - END -->

                            <!-- About -->
                            <section class="flex flex-col gap-1">
                                <p
                                    class="m-0 hidden text-sm font-semibold uppercase tracking-widest text-secondary lg:block">
                                    About</p>
                                @if (creator.bio) {
                                <p class="m-0 whitespace-pre-wrap text-base font-normal text-primary">{{ creator.bio }}
                                </p>
                                } @else {
                                <p class="m-0 text-base font-semibold text-secondary italic">Bio not set..</p>
                                }
                            </section>
                            <!-- About - END -->

                            <!-- Interests -->
                            @if (creator.interests.length) {
                            <div class="hidden flex-wrap gap-1.5 lg:flex">
                                @for (interest of creator.interests; track interest) {
                                <p
                                    class="m-0 rounded-full bg-brand-purple/10 px-2.5 py-1 text-xs font-semibold text-brand-agency-dark dark:bg-brand-purple/25 dark:text-primary">
                                    {{ formatService.getInterestText(interest) }}
                                </p>
                                }
                            </div>
                            }
                            <!-- Interests - END -->

                            <!-- Delivery Address -->
                            @if (deliveryAddressVisible()) {
                            <mgc-delivery-address [creator]="creator"></mgc-delivery-address>
                            }
                            <!-- Delivery Address - END -->

                            <!-- Creator ID -->
                            <div class="flex items-center gap-2">
                                <p class="m-0 min-w-0 truncate font-mono text-xs text-secondary">ID {{
                                    creator.blazeFirebaseUid }}</p>
                                <button type="button" (click)="copyCreatorId()"
                                    class="inline-flex size-7 shrink-0 items-center justify-center rounded-md text-secondary hover:bg-card hover:text-primary"
                                    aria-label="Copy creator ID">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="2" class="size-3.5" aria-hidden="true">
                                        <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
                                        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                                    </svg>
                                </button>
                                @if (isAdmin()) {
                                <button type="button" (click)="openMissionControlModeration()"
                                    class="btn-shout btn-shout-xs btn-shout-secondary shrink-0"
                                    aria-label="Open Mission Control moderation">MC</button>
                                }
                            </div>
                            <!-- Creator ID - END -->

                            <!-- Recent Collaborations -->
                        </div>
                    </div>
                    <!-- Sidebar Main - END-->
                    <!-- Sidebar Footer -->
                    <div class="shrink-0 w-full overflow-hidden p-2 pb-0 flex flex-col gap-y-4">
                        @if (primaryAction() === 'hire') {
                        <button type="button" (click)="openHireDrawer()"
                            class="inline-flex items-center justify-center gap-x-1.5 rounded-full primary-go-button px-6 hover:cursor-pointer">
                            @if (hirePaymentMethodType(); as paymentType) {
                            @if (paymentType === PaymentMethodTypeEnum.CASH) {
                            Hire - {{ hirePrice() | currency : hireCurrencyCode() : 'symbol' : '1.2-2' }}
                            } @else {
                            Hire
                            <sp-remuneration-type-icon [type]="paymentType" iconClass="size-5" />
                            }
                            } @else {
                            Hire - {{ hirePrice() | currency : hireCurrencyCode() : 'symbol' : '1.2-2' }}
                            }
                        </button>
                        } @else if (primaryAction() === 'collaborate') {
                        <button type="button" (click)="collaboratorsService.selectCreator(creatorState()!)"
                            class="inline-flex items-center justify-center gap-x-1.5 rounded-full primary-go-button px-6 hover:cursor-pointer">
                            Collaborate
                        </button>
                        } @else if (primaryAction() === 'unselect') {
                        <button type="button" (click)="collaboratorsService.removeCreator(creatorState()!)"
                            class="inline-flex items-center justify-center gap-x-1.5 rounded-full primary-go-button px-6 hover:cursor-pointer">
                            Un-Select
                        </button>
                        }

                        <div class="flex flex-row items-center justify-center gap-x-2">
                            <a class="flex-1 inline-flex items-center justify-center gap-x-2.5 rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20"
                                [class]="publicMediaKitUrl ? '' : 'pointer-events-none opacity-60'"
                                [href]="publicMediaKitUrl" [attr.target]="publicMediaKitUrl ? '_blank' : null"
                                [attr.rel]="publicMediaKitUrl ? 'noopener noreferrer' : null"
                                [attr.aria-disabled]="publicMediaKitUrl ? null : true">
                                Media Kit
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5" aria-hidden="true">
                                    <path d="M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6" />
                                    <path d="m21 3-9 9" />
                                    <path d="M15 3h6v6" />
                                </svg>
                            </a>
                            <button type="button" (click)="openAddToGroup()"
                                class="flex-1 inline-flex items-center justify-center gap-x-2.5 rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20">
                                Add to Group
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5">
                                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                    <circle cx="9" cy="7" r="4" />
                                    <line x1="19" x2="19" y1="8" y2="14" />
                                    <line x1="22" x2="16" y1="11" y2="11" />
                                </svg>
                            </button>
                            <button (click)="openAdminUserProfile()" type="button"
                                class="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5">
                                    <path
                                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                                </svg>
                            </button>

                        </div>
                    </div>
                    <!-- Sidebar Footer - END-->
                </article>
                <article
                    class="col-span-2 h-full briefing-section-card p-4 overflow-hidden flex flex-col divide-y divide-gray-200 dark:divide-white/10">
                    <!-- Main Content Header -->
                    <div class="shrink-0 flex flex-row items-center justify-between gap-x-4 pb-2">

                        <div class="flex-1">
                            <nav aria-label="Tabs" class="flex min-w-0 gap-2 overflow-x-auto scrollbar-transparent">
                                @for (tab of tabs; track tab) {
                                <a (click)="setSelectedTab(tab)"
                                    class="shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                                    [class]="getTabClass(tab)">{{ getTabLabel(tab) }}</a>
                                }
                            </nav>
                        </div>

                        @if (selectedTab() === 'socials') {
                        <div class="shrink-0 flex flex-row items-center justify-end gap-x-2">
                            <div>
                                <div class="grid grid-cols-1 sm:hidden">
                                    <select aria-label="Select a tab" [value]="selectedTab_Socials()"
                                        (change)="onSocialTabChange($event)"
                                        class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pr-8 pl-3 text-sm font-medium text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 dark:bg-white/5 dark:text-gray-100 dark:outline-white/10 dark:focus:outline-indigo-500">
                                        @for (tab of social_network_tabs; track tab) {
                                        <option [value]="tab">{{ getTabLabel_Socials(tab) }}</option>
                                        }
                                    </select>
                                    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"
                                        class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500 dark:fill-gray-400">
                                        <path
                                            d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </div>
                                <div class="hidden sm:block">
                                    <nav aria-label="Tabs"
                                        class="isolate flex divide-x divide-gray-200 rounded-lg bg-white shadow-sm dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10">
                                        @for (tab of social_network_tabs; track tab) {
                                        <a (click)="setSelectedTab_Socials(tab)"
                                            [attr.aria-current]="selectedTab_Socials() === tab ? 'page' : null"
                                            [class]="getTabClass_Socials(tab)">
                                            <span>{{ getTabLabel_Socials(tab) }}</span>
                                            <span aria-hidden="true" [class]="getSocialTabIndicatorClass(tab)"></span>
                                        </a>
                                        }
                                    </nav>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                    <!-- Main Content Header - END -->

                    <!-- Main Content Body -->
                    @switch(selectedTab()) {
                    @case('portfolio') {
                    @for (creatorId of [creator.blazeFirebaseUid]; track creatorId) {
                    <div class="flex-1 overflow-y-auto">
                        <mgc-portfolio [creator]="creator" (videoCount)="onPortfolioCount($event)"></mgc-portfolio>
                    </div>
                    }
                    }
                    @case('socials') {
                    <div class="flex-1 overflow-y-auto">
                        @if (ultraSocialStatus() === 'loading') {
                        <atom-loading-inline title="Social accounts"
                            message="Loading connected accounts..."></atom-loading-inline>
                        } 
                        @else {
                        @for (socialKey of [socialContentKey()]; track socialKey) {
                        @switch(selectedTab_Socials()) {
                        @case('tiktok') {
                        <mgc-tiktok [creator]="creator" [ultra_social_tiktok]="us_tiktok()"
                            [ultra_social_creator_id]="us_creator_id()"></mgc-tiktok>
                        }
                        @case('instagram') {
                        <mgc-instagram [creator]="creator" [ultra_social_instagram]="us_instagram()"
                            [ultra_social_creator_id]="us_creator_id()"></mgc-instagram>
                        }
                        @case('youtube') {
                        <mgc-youtube [creator]="creator" [ultra_social_youtube]="us_youtube()"
                            [ultra_social_creator_id]="us_creator_id()"></mgc-youtube>
                        }
                        @case('snapchat') {
                        <mgc-snapchat [creator]="creator" [ultra_social_snapchat]="us_snapchat()"
                            [ultra_social_creator_id]="us_creator_id()"></mgc-snapchat>
                        }
                        }
                        }
                        }
                    </div>
                    }
                    @case('reviews') {
                    <div class="flex-1 overflow-y-auto">
                        <div class="h-full overflow-y-auto" #reviewsScrollDiv infinite-scroll
                            [infiniteScrollDistance]="scrollDistance" [infiniteScrollUpDistance]="scrollUpDistance"
                            [infiniteScrollThrottle]="throttle" [infiniteScrollContainer]="reviewsScrollDiv"
                            (scrolled)="onScrollDownReviews()">
                            <div class="mb-6 rounded-xl bg-brand-deep-purple p-5 text-white lg:p-7">
                                <div class="flex flex-col gap-6 lg:flex-row lg:items-center lg:gap-12">
                                    <div>
                                        <p class="m-0 text-6xl font-extrabold leading-none">
                                            {{ ratingSummary().rating == null ? '—' : (ratingSummary().rating | number:
                                            '1.1-1') }}
                                        </p>
                                        <p class="m-0 mt-1 text-brand-purple" aria-hidden="true">{{ reviewStars() }}</p>
                                        <p class="m-0 mt-1 text-xs text-white/80">
                                            @if (ratingSummary().count === 1) {
                                            1 review
                                            } @else if (ratingSummary().count != null) {
                                            {{ ratingSummary().count }} reviews
                                            } @else {
                                            Reviews
                                            }
                                        </p>
                                    </div>
                                    @if (reviewOverview().rows.length) {
                                    <div
                                        class="flex min-w-0 flex-1 flex-col gap-2.5 lg:border-l lg:border-white/15 lg:pl-12">
                                        @for (row of reviewOverview().rows; track row.label) {
                                        <div class="flex items-center gap-2">
                                            <p class="m-0 w-24 shrink-0 text-xs text-white/80">{{ row.label }}</p>
                                            <div class="h-1.5 min-w-0 flex-1 overflow-hidden rounded-full bg-white/15"
                                                aria-hidden="true">
                                                <div class="h-full rounded-full bg-brand-purple"
                                                    [style.width.%]="barWidth(row.score)"></div>
                                            </div>
                                            <p class="m-0 shrink-0 text-right text-xs font-bold">{{
                                                formatScore(row.score) }}</p>
                                        </div>
                                        }
                                    </div>
                                    }
                                    @if (reviewList().count) {
                                    <div class="lg:border-l lg:border-white/15 lg:pl-12">
                                        <p class="m-0 text-4xl font-extrabold leading-none">{{
                                            reviewOverview().rehireLabel }}</p>
                                        <p
                                            class="m-0 mt-1 text-base font-semibold uppercase tracking-widest text-white/80">
                                            Would rehire</p>
                                    </div>
                                    }
                                </div>
                            </div>

                            @if (reviewList().error && reviewList().items.length === 0) {
                            <div class="flex justify-center py-8">
                                <button type="button" (click)="retryReviews()"
                                    class="btn-shout btn-shout-sm btn-shout-secondary">
                                    Couldn't load reviews · Retry
                                </button>
                            </div>
                            } @else if (reviewList().loading && reviewList().items.length === 0) {
                            <div class="flex flex-col gap-3">
                                @for (skeleton of [1, 2]; track skeleton) {
                                <div class="rounded-xl border border-border bg-card p-4" aria-hidden="true">
                                    <div class="h-4 w-1/3 animate-pulse rounded bg-muted"></div>
                                    <div class="mt-3 h-4 w-3/4 animate-pulse rounded bg-muted"></div>
                                    <div class="mt-2 h-4 w-1/2 animate-pulse rounded bg-muted"></div>
                                </div>
                                }
                            </div>
                            } @else if (reviewList().count === 0) {
                            <div
                                class="flex min-h-72 flex-col items-center justify-center rounded-xl border border-dashed border-border bg-muted/50 px-6 py-16 text-center">
                                <div class="flex size-14 items-center justify-center rounded-full bg-card text-secondary shadow-sm ring-1 ring-border"
                                    aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="1.5" class="size-7">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                                    </svg>
                                </div>
                                <h3 class="m-0 mt-4 text-lg font-semibold text-primary">No reviews yet</h3>
                                <p class="m-0 mt-2 max-w-md text-sm leading-relaxed text-secondary">
                                    After this creator finishes a brief, brand feedback lands here — overall score,
                                    would-rehire rate, and notes on quality and communication.
                                </p>
                            </div>
                            } @else {
                            <div class="flex flex-col gap-3">
                                @for (review of reviewList().items; track $index) {
                                <article class="rounded-xl border border-border bg-card p-4 shadow-sm">
                                    <div class="flex items-start gap-3">
                                        @if (review.application?.brief?.businessAccount?.companyLogo) {
                                        <img class="size-10 shrink-0 rounded-full border border-border object-cover"
                                            [src]="imageService.getImageSource(review.application?.brief?.businessAccount?.companyLogo, 'gallery')"
                                            alt="" />
                                        } @else {
                                        <p
                                            class="m-0 flex size-10 shrink-0 items-center justify-center rounded-full border border-border bg-muted text-sm font-bold text-primary">
                                            {{ brandMonogram(review.application?.brief?.businessAccount?.companyName) }}
                                        </p>
                                        }
                                        <div class="min-w-0 flex-1">
                                            <div class="flex flex-wrap items-baseline gap-2">
                                                <h3 class="m-0 text-lg font-bold text-primary">
                                                    {{ review.application?.brief?.businessAccount?.companyName ||
                                                    'Brand' }}
                                                </h3>
                                                <p class="m-0 text-xs text-secondary">
                                                    {{ review.application?.brief?.title }}
                                                    @if (review.application?.brief?.title && review.createdDate) {
                                                    <span aria-hidden="true"> · </span>
                                                    }
                                                    @if (review.createdDate) {
                                                    {{ review.createdDate | date: 'MMM yyyy' }}
                                                    }
                                                </p>
                                            </div>
                                            @if (review.review) {
                                            <p class="m-0 mt-2 text-lg font-semibold text-primary">{{ review.review }}
                                            </p>
                                            }
                                            <p class="m-0 mt-2 text-xs text-secondary">
                                                Comms {{ formatScore(review.communicationRating ?? null) }}
                                                · Prof. {{ formatScore(review.professionalismRating ?? null) }}
                                                · Time {{ formatScore(review.timeManagementRating ?? null) }}
                                                · Quality {{ formatScore(review.workQualityRating ?? null) }}
                                            </p>
                                        </div>
                                        <div class="shrink-0 text-right">
                                            @if (reviewOverall(review); as overall) {
                                            <p class="m-0 text-xl font-extrabold text-primary">{{ formatScore(overall)
                                                }}/5</p>
                                            } @else {
                                            <p class="m-0 text-xl font-extrabold text-primary">—</p>
                                            }
                                        </div>
                                    </div>
                                </article>
                                }

                                @if (reviewList().loading) {
                                @for (skeleton of [1, 2]; track skeleton) {
                                <div class="rounded-xl border border-border bg-card p-4" aria-hidden="true">
                                    <div class="size-10 animate-pulse rounded-full bg-brand-purple/10"></div>
                                    <div class="mt-3 h-3 w-1/3 animate-pulse rounded bg-muted"></div>
                                    <div class="mt-2 h-3 w-3/4 animate-pulse rounded bg-muted"></div>
                                </div>
                                }
                                }

                                @if (reviewList().error) {
                                <div class="flex justify-center py-4">
                                    <button type="button" (click)="retryReviews()"
                                        class="btn-shout btn-shout-sm btn-shout-secondary">
                                        Couldn't load more reviews · Retry
                                    </button>
                                </div>
                                } @else if (!hasMoreReviews() && reviewList().items.length > 0) {
                                <div class="flex items-center gap-3 py-4">
                                    <div class="h-px flex-1 bg-border"></div>
                                    <p class="m-0 text-xs font-semibold uppercase tracking-widest text-secondary">
                                        All {{ reviewList().count }} reviews loaded
                                    </p>
                                    <div class="h-px flex-1 bg-border"></div>
                                </div>
                                }
                            </div>
                            }
                        </div>
                    </div>
                    }
                    }
                    <!-- Main Content Body - END -->
                </article>
            </div>

            <div aria-hidden="true"
                class="absolute inset-x-0 top-[calc(100%-13rem)] transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]">
                </div>
            </div>

        </div>
    </div>

    @if (showAddToGroup()) {
    <ambala-groups [creator]="creator" (closed)="closeAddToGroup()"></ambala-groups>
    }
</div>